import { render, staticRenderFns } from "./ScreenMama.vue?vue&type=template&id=631cb054&scoped=true&"
import script from "./ScreenMama.vue?vue&type=script&lang=js&"
export * from "./ScreenMama.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMama.vue?vue&type=style&index=0&id=631cb054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cb054",
  null
  
)

export default component.exports